export const EMPTY_TEXT = {};